import { createModalsFactory } from 'ui';

type CommunicationListsModalIds = 'CommunicationLists' | 'CauseStatus' | 'Unsubscribe' | 'Unfollow';
type CommunicationListsModalMeta = { causeId?: string };

const {
  Provider: CommunicationListsModalProvider,
  useProvider: useCommunicationListsModalProvider,
  ModalTitleWithBackButton,
} = createModalsFactory<CommunicationListsModalIds[], CommunicationListsModalMeta>([
  'CommunicationLists',
  'CauseStatus',
  'Unsubscribe',
  'Unfollow',
]);

export {
  CommunicationListsModalProvider,
  ModalTitleWithBackButton,
  useCommunicationListsModalProvider,
};
